import { cityTitle } from "./WishItem";
import { DndContext, closestCenter, PointerSensor, TouchSensor, KeyboardSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, verticalListSortingStrategy, useSortable, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, ChevronUp, ChevronDown, ChevronsUp } from "lucide-react";

const Row = ({ w, i, last, move, cityFirst }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: w.id });
  const btn = "p-1 text-slate-500 hover:text-white disabled:opacity-20 disabled:pointer-events-none transition-colors";
  return (
    <li ref={setNodeRef} style={{ transform: CSS.Transform.toString(transform), transition }}
      className={`flex items-center gap-2 h-9 px-2 rounded-md select-none ${isDragging ? "bg-amber-500/15 ring-1 ring-amber-400/50 relative z-10" : "hover:bg-white/[0.04]"}`}
      data-testid={`quick-row-${i + 1}`}>
      <button {...attributes} {...listeners} className="text-slate-500 hover:text-slate-200 cursor-grab active:cursor-grabbing touch-none" aria-label={`Drag ${w.country}`} data-testid={`quick-drag-${i + 1}`}><GripVertical size={14} /></button>
      <span className="font-mono text-[11px] text-amber-400 w-6">{String(i + 1).padStart(2, "0")}</span>
      <span className="flex-1 truncate text-sm" data-testid={`quick-country-${i + 1}`}>{cityFirst ? <>{cityTitle(w.cities)} <span className="text-[10px] uppercase tracking-wider text-slate-500">{w.country}</span></> : w.country}</span>
      <button disabled={i === 0} onClick={() => move(i, 0)} className={btn} aria-label="Move to top" data-testid={`quick-top-${i + 1}`}><ChevronsUp size={14} /></button>
      <button disabled={i === 0} onClick={() => move(i, i - 1)} className={btn} aria-label="Move up" data-testid={`quick-up-${i + 1}`}><ChevronUp size={14} /></button>
      <button disabled={last} onClick={() => move(i, i + 1)} className={btn} aria-label="Move down" data-testid={`quick-down-${i + 1}`}><ChevronDown size={14} /></button>
    </li>
  );
};

export const QuickReorder = ({ wishlist, move, been }) => {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 4 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 120, tolerance: 6 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    move(wishlist.findIndex((w) => w.id === active.id), wishlist.findIndex((w) => w.id === over.id));
  };
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={onDragEnd}>
      <SortableContext items={wishlist.map((w) => w.id)} strategy={verticalListSortingStrategy}>
        <ol className="rounded-xl border border-white/5 bg-white/[0.02] p-1 divide-y divide-white/[0.04]" data-testid="quick-reorder-list">
          {wishlist.map((w, i) => <Row key={w.id} w={w} i={i} last={i === wishlist.length - 1} move={move} cityFirst={been.has(w.country) && (w.cities || []).length > 0} />)}
        </ol>
      </SortableContext>
    </DndContext>
  );
};
